export default __webpack_public_path__ + "static/media/bills_import_template_example.6248ca65.csv";